import { UPDATE_PRICING, CLEAR_PRICING, GET_PRICING_ERROR } from '../actions/actionTypes';

export default (state = { pricingError: false }, action) => {
  switch (action.type) {
    case UPDATE_PRICING: {
      const { type, ...newState } = action;
      return newState;
    }
    case CLEAR_PRICING: {
      const { type, ...newState } = action;
      return newState;
    }
    case GET_PRICING_ERROR: {
      return {
        ...state,
        pricingError: true,
      };
    }
    default:
      return state;
  }
};
